module.exports = __webpack_public_path__ + "img/laptop.cc617716.png";